import { render, staticRenderFns } from "./Mbmenu.vue?vue&type=template&id=7e755c6f&scoped=true"
import script from "./Mbmenu.vue?vue&type=script&lang=js"
export * from "./Mbmenu.vue?vue&type=script&lang=js"
import style0 from "./Mbmenu.vue?vue&type=style&index=0&id=7e755c6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e755c6f",
  null
  
)

export default component.exports